import { render } from "./copy.vue?vue&type=template&id=12f1fdb9"
import script from "./copy.vue?vue&type=script&lang=js"
export * from "./copy.vue?vue&type=script&lang=js"

import exportComponent from "D:\\newProjectGit\\HbzsbAdminClient\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__